// extracted by mini-css-extract-plugin
var _1 = "MenuHover__arrow--mmx2M";
var _2 = "MenuHover__closed--mqfyq MenuHover__menu--CAYFp";
var _3 = "MenuHover__hoverable--AXucS";
var _4 = "MenuHover__label--e3knA";
var _5 = "MenuHover__labelOpen--CQGVd MenuHover__label--e3knA";
var _6 = "MenuHover__menu--CAYFp";
var _7 = "MenuHover__open--fYKQX MenuHover__menu--CAYFp";
var _8 = "MenuHover__small--PpZ3d";
var _9 = "MenuHover__triangle--od6jd";
var _a = "MenuHover__triangleClosed--UDrR6";
export { _1 as "arrow", _2 as "closed", _3 as "hoverable", _4 as "label", _5 as "labelOpen", _6 as "menu", _7 as "open", _8 as "small", _9 as "triangle", _a as "triangleClosed" }
